const name = 'Kristian Nikolov';
const role = 'Assistant Product Manager';
const text = `Kristian Nikolov graduated with a B.S. in Computer Engineering from NYU,
and has been developing both front and back end for DataMixMaster for 3 years.`;

const kristianNikolov = { name, role, text };

export default kristianNikolov;
